import { Redirect, Route, RouteProps } from 'react-router-dom';
import { AuthContextProps, useAuth } from '../../context/auth.context';
import { Paths } from '../../../routes';

interface PrivateRouteProps extends RouteProps {
  component: any;
}

export default function PrivateRoute({
  component: Component,
  ...rest
}: PrivateRouteProps) {
  const { authorizing, currentUser } = useAuth() as AuthContextProps;

  if (authorizing) return <p>loading</p>;

  return (
    <Route
      {...rest}
      render={(props) => {
        return currentUser ? (
          <Component {...props} currentUser={currentUser} />
        ) : (
          <Redirect to={Paths.login} />
        );
      }}
    ></Route>
  );
}
